import { apiService } from './api';
import { isProfileComplete } from './profile';

/**
 * Check if profile is complete and get country from attestation if needed
 * Returns an object with:
 * - isComplete: boolean indicating if profile is complete
 * - country: string from attestation (if available)
 * - shouldRedirect: boolean indicating if user should be redirected to complete-profile
 */
export const checkProfileCompletion = async (): Promise<{
  isComplete: boolean;
  country?: string;
  shouldRedirect: boolean;
}> => {
  try {
    // Get user profile
    const profile = await apiService.getUserProfile();
    const complete = isProfileComplete(profile);

    // If profile is complete, no need to get country
    if (complete) {
      return {
        isComplete: true,
        shouldRedirect: false
      };
    }

    // If profile is incomplete, try to get country from attestation
    let country: string | undefined;
    try {
      const attestations = await apiService.getAttestations();
      // Get the most recent attestation
      if (attestations && attestations.length > 0) {
        const latestAttestation = attestations.sort(
          (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        )[0];
        country = latestAttestation.country;
      }
    } catch (err) {
      // If we can't get attestation, that's okay - country will be undefined
    }

    return {
      isComplete: false,
      country,
      shouldRedirect: true
    };
  } catch (error) {
    console.error('Error checking profile completion:', error);
    // On error, assume profile is incomplete to be safe
    return {
      isComplete: false,
      shouldRedirect: true
    };
  }
};

